module.exports = {
  convertDateToNorwegianStyleString: function(newDate) {
    if (typeof newDate === 'undefined' || newDate === null) {
      return null;
    }
    var tmpDate = new Date(newDate);
    return (
      tmpDate.getDate() +
      '.' +
      (tmpDate.getMonth() + 1) +
      '.' +
      tmpDate.getFullYear()
    );
  },
  getTimeStringFromDate: function(newDate) {
    if (typeof newDate === 'undefined' || newDate === null) {
      return null;
    }
    var tmpDate = new Date(newDate);
    var hours = tmpDate.getHours().toString();
    var minutes = tmpDate.getMinutes().toString();
    if (hours.length === 1) {
      hours = '0' + hours;
    }
    if (minutes.length === 1) {
      minutes = '0' + minutes;
    }
    return hours + ':' + minutes;
  }
};
